import styled from "@emotion/styled";

import { getButtonSizeStyles, getButtonVariantStyles } from "./button-styles";
import type { StyledButtonProps } from "./types";

export const StyledButton = styled.button<StyledButtonProps>`
  /* Base styles */
  display: inline-flex;
  align-items: center;
  justify-content: center;
  gap: 8px;
  border: none;
  outline: none;
  transition: all 0.2s ease-in-out;
  cursor: pointer;
  white-space: nowrap;
  text-decoration: none;
  font-weight: 500;
  border-radius: 5px;

  /* Apply default size styles if no custom sizing is provided */
  ${({ $size = "medium", $styleProps }) =>
    !$styleProps?.padding && !$styleProps?.fontSize
      ? getButtonSizeStyles($size)
      : ""}

  /* Apply default variant styles if no custom colors are provided */
  ${({ $variant, $styleProps }) =>
    getButtonVariantStyles($variant, $styleProps)}

  /* Apply width and height styles if provided */
  ${({ $styleProps }) => $styleProps?.width && `width: ${$styleProps.width};`}
  ${({ $styleProps }) =>
    $styleProps?.height && `height: ${$styleProps.height};`}

  /* Apply box shadow styles if provided */
  ${({ $styleProps }) =>
    $styleProps?.boxShadow && `box-shadow: ${$styleProps.boxShadow};`}

  /* Apply hover box shadow styles if provided */
  &:hover {
    ${({ $styleProps }) =>
      $styleProps?.hoverBoxShadow &&
      `box-shadow: ${$styleProps.hoverBoxShadow};`}
  }

  /* Apply active box shadow styles if provided */
  &:active {
    ${({ $styleProps }) =>
      $styleProps?.activeBoxShadow &&
      `box-shadow: ${$styleProps.activeBoxShadow};`}
  }

  /* Disabled state */
  &:disabled {
    opacity: 0.5;
    cursor: not-allowed;
  }
`;

export const LoadingSpinner = styled.div`
  width: 16px;
  height: 16px;
  border: 2px solid transparent;
  border-top: 2px solid currentColor;
  border-radius: 50%;
  animation: spin 1s linear infinite;

  @keyframes spin {
    0% {
      transform: rotate(0deg);
    }
    100% {
      transform: rotate(360deg);
    }
  }
`;
